import { render, staticRenderFns } from "./RedeemsQueue.vue?vue&type=template&id=7bb78e4c&scoped=true"
import script from "./RedeemsQueue.vue?vue&type=script&lang=js"
export * from "./RedeemsQueue.vue?vue&type=script&lang=js"
import style0 from "./RedeemsQueue.vue?vue&type=style&index=0&id=7bb78e4c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bb78e4c",
  null
  
)

export default component.exports